import { useState, useEffect } from 'react';

interface CardSkeletonProps {
  lines?: number;
  showHeader?: boolean;
}

export default function CardSkeleton({ lines = 3, showHeader = true }: CardSkeletonProps) {
  return (
    <div className="bg-card rounded-2xl p-4 border border-border shadow animate-pulse">
      {showHeader && (
        <div className="flex items-center gap-3 mb-4">
          <div className="w-3 h-3 rounded-full bg-border shimmer" />
          <div className="h-4 w-32 bg-border rounded shimmer" />
        </div>
      )}
      <div className="space-y-3">
        {Array.from({ length: lines }).map((_, i) => (
          <div
            key={i}
            className="h-3 bg-border rounded shimmer"
            style={{ width: `${85 - i * 15}%` }}
          />
        ))}
      </div>
    </div>
  );
}
